import React from "react";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";

export default function MasterLikeTable({ columns, rows, onEdit, onLogicalDelete, hideDelete, isRowEditable }) {
  return (
    <TableContainer className={"box-shadow"} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
              Sl.No
            </TableCell>
            {columns.map((c) => (
              <TableCell key={c.key} align="left" sx={{ color: "#B3B3B3" }}>
                {c.label}
              </TableCell>
            ))}
            <TableCell colSpan={2} align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.length > 0 ? (
            rows.map((r, idx) => (
              <TableRow hover key={r.id || idx}>
                <TableCell>{idx + 1}</TableCell>
                {columns.map((c) => (
                  <TableCell key={`${r.id}_${c.key}`} sx={{ color: "#3D3D3D" }}>
                    {r?.[c.key] ?? "-"}
                  </TableCell>
                ))}
                <TableCell align="right">
                  {(isRowEditable?.(r) ?? true) && (
                    <Tooltip title={"Edit/Review"}>
                      <IconButton
                        onClick={() => onEdit?.(r)}
                        sx={{ bgcolor: "#fff", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;" }}
                      >
                        <DriveFileRenameOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell align="right">
                  {!hideDelete && (
                    <Tooltip title={"Make inactive"}>
                      <IconButton onClick={() => onLogicalDelete?.(r.id)}>
                        <DeleteForeverIcon sx={{ color: "red" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length + 3} style={{ textAlign: "center" }}>
                <Typography style={{ color: "red" }}>No records</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
